import { createActionConfig } from './create-action-config';

export const type = '@appcues/submit-form';
export const getSubmitForm = config =>
  createActionConfig({
    type,
    config,
  });
